<template>
  <div class="preview-window preview-window__wrapper">
    <img class="preview-window preview-window__image" v-if="store.state.currentLinjeImage != ''" :src="store.state.currentLinjeImage"> 
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
    name: 'PreviewWindow',
    setup() {
        const store = inject('store');
        return {
            store
        }
    }
}
</script>
